import { createApp } from 'vue';
import { mountReplace } from '@/js/utils/mountUtils';
import HotelFeatures from './HotelFeatures.vue';

const mountPoint: HTMLElement | null = document.querySelector('#hotel-features');
if (mountPoint) {
	const hotel = JSON.parse(mountPoint.dataset.hoteldata || '');

	const app = createApp(HotelFeatures, {
		hotel,
	});

	mountReplace(app, mountPoint);
}
